import { Link, NavLink, Navigate, Route, Routes } from "react-router-dom";
import { SignInButton } from "./components/SignInButton";
import { SlatePage } from "./pages/Slate";
import { ModelLabPage } from "./pages/ModelLab";
import { NotFoundPage } from "./pages/NotFound";

export function App() {
  return (
    <div className="app-shell">
      <header className="app-header">
        <Link to="/" className="brand">
          <span className="brand-mark">PB</span>
          <span className="brand-name">Predabet</span>
        </Link>
        <nav className="app-nav">
          <NavLink to="/" end>
            Predictions
          </NavLink>
          <NavLink to="/lab">Model Lab</NavLink>
        </nav>
        <div className="app-auth">
          <SignInButton />
        </div>
      </header>

      <main className="app-main">
        <Routes>
          <Route path="/" element={<SlatePage />} />
          <Route path="/history" element={<Navigate to="/" replace />} />
          <Route path="/lab" element={<ModelLabPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      <footer className="app-footer">
        <span>
          Predabet &middot; WNBA probabilistic predictions &middot; For research
          and entertainment only. No betting advice.
        </span>
      </footer>
    </div>
  );
}
